/* ============================================================
   BLANKPILL — Free Global Shipping corner ribbon (product cards)
   Injects a small diagonal acid ribbon wrapped around the
   top-right corner of every product card's image across
   collection pages, the homepage drop grid, search, and
   recommendations. Sits IN the corner (not a horizontal pill),
   so it never collides with the native red SALE / SOLD OUT
   badge in the top-left, even on narrow single-column grids.

   COLOR FIX: text color is set via setProperty(..., 'important')
   directly on each element's CSSStyleDeclaration. This is the
   strongest priority CSS can have short of a later !important
   rule targeting the exact same element with equal specificity
   appended after this script runs — i.e. it beats every external
   stylesheet rule unconditionally. A periodic re-assert loop also
   runs for a few seconds after injection in case any other script
   on the page (app embeds, Shopify's own morph/section-replace on
   filter or sort changes) touches these nodes afterward. Also
   removes any leftover nodes from the previous pill-shaped badge
   (class bp-card-ship-badge) so two versions never show at once.

   Pure additive DOM injection — fully reversible by removing this
   file + its <script> tag.
   ============================================================ */
(function () {
  'use strict';

  var WRAP_CLASS = 'bp-card-ship-corner';
  var RIBBON_CLASS = 'bp-card-ship-corner__ribbon';
  var OLD_BADGE_CLASS = 'bp-card-ship-badge'; // previous pill version — remove if present
  var TEXT_COLOR = '#080808';

  function forceBlack(el) {
    if (!el || !el.style) return;
    el.style.setProperty('color', TEXT_COLOR, 'important');
  }

  function findMediaContainer(card) {
    return (
      card.querySelector('.card-gallery') ||
      card.querySelector('.card__media-wrapper') ||
      card.querySelector('.product-card__media') ||
      card.querySelector('.bp-product-img-wrap') ||
      card
    );
  }

  function removeOldBadges(card) {
    var olds = card.querySelectorAll('.' + OLD_BADGE_CLASS);
    olds.forEach(function (n) { n.remove(); });
  }

  function buildRibbon() {
    var ribbon = document.createElement('div');
    ribbon.className = RIBBON_CLASS;

    var line1 = document.createElement('span');
    line1.textContent = 'Free';
    var line2 = document.createElement('span');
    line2.textContent = 'Shipping';
    var line3 = document.createElement('span');
    line3.textContent = '$60+';

    [line1, line2, line3].forEach(function (line, i) {
      forceBlack(line);
      ribbon.appendChild(line);
      if (i < 2) ribbon.appendChild(document.createElement('br'));
    });

    forceBlack(ribbon);
    return ribbon;
  }

  function addBadge(card) {
    removeOldBadges(card);
    if (card.querySelector('.' + WRAP_CLASS)) {
      reassertColors(card);
      return;
    }
    var container = findMediaContainer(card);
    if (!container) return;

    var style = window.getComputedStyle(container);
    if (style.position === 'static') {
      container.style.position = 'relative';
    }

    var wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;
    wrap.appendChild(buildRibbon());
    container.appendChild(wrap);
  }

  function reassertColors(card) {
    var ribbon = card.querySelector('.' + RIBBON_CLASS);
    if (!ribbon) return;
    forceBlack(ribbon);
    ribbon.querySelectorAll('span').forEach(forceBlack);
  }

  function scan() {
    document.querySelectorAll('product-card, .product-card, .bp-product-card').forEach(addBadge);
  }

  function start() {
    scan();
    // Belt-and-suspenders re-scans: covers collection pages where infinite
    // scroll / facet filtering / section morphing swaps content in via
    // mechanisms the MutationObserver below might miss, and re-asserts
    // the forced text color in case anything touched these nodes after
    // initial injection.
    [150, 300, 600, 1200, 2500, 4000].forEach(function (ms) {
      setTimeout(scan, ms);
    });
    window.addEventListener('load', scan);
    try {
      var mo = new MutationObserver(function () { scan(); });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('page:loaded', start);
})();
